<template>
    <div 
        :class="[
            'chart-container',
            (size=='sm')?'chart-container--small':''
        ]" 
    >
        <canvas id="chart-gauge" class="chart-gauge gauge-small"></canvas>
    </div>
   
</template>

<script>
import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css'; 
import Chart from 'chart.js';
import 'chartjs-gauge';
export default {
    name:"chart_gauge",
    data(){
        return {
            ctx:null,
            value_needle:0,
            chart:null,
            tooltip:null,
            config:{
                type: 'gauge',
                data: {
                    labels: [], // 
                    datasets: [
                        {
                            data: [100], //
                            value: 0, //
                            backgroundColor: [],
                            borderWidth: 2
                        }
                    ]
                },
                options: {
                    /* responsive: true, */
                    maintainAspectRatio: false,
                    title: {
                        display: false
                    },
                    layout: {
                        padding: {
                            bottom: 5
                        }
                    },
                    needle: {
                        // Needle circle radius as the percentage of the chart area width
                        radiusPercentage: 2,
                        // Needle width as the percentage of the chart area width
                        widthPercentage: 3.2,
                        // Needle length as the percentage of the interval between inner radius (0%) and outer radius (100%) of the arc
                        lengthPercentage: 80,
                        // The color of the needle
                        color: 'rgba(0, 0, 0, 1)'
                    },
                    valueLabel: {
                        formatter: Math.round,
                        display:false
                    },
                    /* plugins: {
                        datalabels: {
                            display: true,
                            formatter:  function (value, context) {
                            return context.chart.data.labels[context.dataIndex];
                            },
                            //color: function (context) {
                            //  return context.dataset.backgroundColor;
                            //},
                            color: 'rgba(0, 0, 0, 1.0)',
                            //color: 'rgba(255, 255, 255, 1.0)',
                            backgroundColor: null,
                            font: {
                            size: 20,
                            weight: 'bold'
                            }
                        }
                    } */
                }
            }
        }
    },
    props:{
        label:{
            default:null
        },
        value:{
            default:0
        },
        reverse:{
            default:false
        },
        size:{
            default:undefined
        }
    },
    computed:{
        backgroundColor:function(){
            if(this.reverse){
                if(this.value<25){
                    return 'green';
                }else if(this.value<50){
                    return 'yellow';
                }else if(this.value<75){
                    return 'orange';
                }else{
                    return 'red';
                }
            }else{
                if(this.value<25){
                    return 'red';
                }else if(this.value<50){
                    return 'orange';
                }else if(this.value<75){
                    return 'yellow';
                }else{
                    return 'green';
                }
            }
            
        },
        value_percent:function(){
            return this.value + '%';
        }
    },
    watch:{
        value(newValue){
            this.value_needle = newValue;
        },
        value_needle(newValue){
            this.config.data.datasets[0].value = newValue;
            this.config.data.datasets[0].backgroundColor = [this.backgroundColor];
            this.initCustomTooltip();
            if(this.ctx)
                // this.chart = new Chart(this.ctx, this.config);
                this.chart.update();
        }
        
    },
    methods:{
        initChart(){
            this.config.data.labels = [this.label];
            this.config.data.datasets[0].value = (this.value) ? this.value:this.value_needle; 
            this.config.data.datasets[0].backgroundColor = [this.backgroundColor];
            this.ctx = this.$el.querySelector('canvas').getContext('2d');
            this.chart = new Chart(this.ctx, this.config);
        },
        initCustomTooltip(){
            this.tooltip = tippy(this.$el, {
                content: this.value_percent,
            });  
        }



    },
    mounted(){
        this.initChart();
        this.initCustomTooltip();
    }
}
</script>

<style lang="scss" scoped>
    .chart-container{
        position: relative;
        width: 100% !important;
        height: auto !important;
    }

    .chart-container--small{
        width: 3.5rem !important;
    }
    
    .chart-gauge.gauge-small{
        width: 4em !important;
        height: 3em !important;
        
    }
</style>